import selectorReducerFor, { selectorInitialState, SelectorState } from '../redux/selector/reducerFor'
import { VersionAction } from './actions'
import { API } from '../../remote-api/models'
import fetchReducerFor, { fetchInitialState, FetchState } from '../redux/fetch/reducerFor'
import { VERSION_PREFIX, VERSION_RESOURCE_NAME } from './model'

export type VersionSelectorState = SelectorState<API>
export type VersionFetcherState = FetchState<API[]>

export const versionSelectorInitialState = {...selectorInitialState}

export const versionSelectorReducer = (origin?: string) => {
  const versionReducerForOrigin = selectorReducerFor<API>(VERSION_RESOURCE_NAME, VERSION_PREFIX, origin)
  return function reducer(state: VersionSelectorState = versionSelectorInitialState, action: VersionAction): VersionSelectorState {
    return {
      ...state,
      ...versionReducerForOrigin(state, action)
    }
  }
}

export const versionFetcherReducer = (origin?: string) => {
  const versionReducerForOrigin = fetchReducerFor<API[]>(VERSION_RESOURCE_NAME, VERSION_PREFIX, origin)
  return function reducer(state: VersionFetcherState = {...fetchInitialState}, action: VersionAction): VersionFetcherState {
    return {
      ...state,
      ...versionReducerForOrigin(state, action)
    }
  }
}
